<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <form @submit.prevent="getRecords()">
          <div class="flex mb-1 flex_gap_10">
            <div class="form-group mb-0">
              <label>Поиск по названию</label>
              <input type="text" v-model="filter.title" placeholder="Препарат" class="form-control">
            </div>
            <div class="form-group mb-0">
              <label>Наличие склада до</label>
              <input type="number" v-model="filter.sb" placeholder="10" class="form-control">
            </div>
            <div class="form-group mb-0">
              <label>Мин. цена</label>
              <input type="number" v-model="filter.mp" placeholder="2000" class="form-control">
            </div>
            <div class="form-group mb-0">
              <label>Дефицит</label>
              <select v-model="filter.def" class="form-control">
                <option value="-1">Все значения</option>
                <option value="1">Только дефицит</option>
                <option value="0">Только не дефицит</option>
              </select>
            </div>
            <div class="form-group mb-0">
              <label>Показать с задачами</label>
              <multiselect
                name="user_role"
                v-model="selectedTasks"
                :options="Object.values(tasksType)"
                placeholder="Выберите задачи"
                track-by="title"
                label="title"
                :showLabels="false"
                :searchable="true"
                :multiple="true">
                <template slot="noResult">Тип задачи не найден</template>
              </multiselect>
            </div>
            <div class="flex justify-content-end ml-2 flex-grow-1">
              <LoadingButton
                title="Показать"
                :loading="loading"
                :color="$constants.SUCCESS_COLOR"
                type="submit"
                :onClick="() => {}"
                className="btn btn-outline-success align-self-start"
              />
            </div>
          </div>
          <div>
            <div class="form-check">
              <label class="pointer">
                <input v-model="filter.hid" :value="3" class="form-check-input" type="radio">
                Показывать только активные, без ветеринарных
              </label>
            </div>
            <div class="form-check">
              <label class="pointer">
                <input v-model="filter.hid" :value="0" class="form-check-input" type="radio">
                Показывать только активные
              </label>
            </div>
            <div class="form-check">
              <label class="pointer">
                <input v-model="filter.hid" :value="4" class="form-check-input" type="radio">
                Показывать только активные ветеринарные
              </label>
            </div>
            <div class="form-check">
              <label class="pointer">
                <input v-model="filter.hid" :value="1" class="form-check-input" type="radio">
                Показывать все
              </label>
            </div>
            <!--            <div class="form-check">-->
            <!--              <label class="pointer">-->
            <!--                <input v-model="filter.hid" :value="2" class="form-check-input" type="radio">-->
            <!--                Показать только скрытые-->
            <!--              </label>-->
            <!--            </div>-->
          </div>
        </form>
        <div v-if="paginator" class="flex justify-content-between mt-2">
          <div>Всего препаратов: <strong>{{ paginator.total }}</strong></div>
          <paginate
            v-model="paginator.current_page"
            :page-count="paginator.last_page"
            ref="Pagination"
            :page-range="11"
            :margin-pages="2"
            :click-handler="getRecords"
            :prev-text="'&laquo'"
            :next-text="'&raquo'"
            :container-class="'pagination'"
            :prev-class="'page-item'"
            :prev-link-class="'page-link'"
            :page-class="'page-item'"
            :page-link-class="'page-link'"
            :next-class="'page-item'"
            :next-link-class="'page-link'"
            :active-class="'active green_btn'">
          </paginate>
        </div>
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>

        <!--        <template v-if="!loading">-->

        <Table003Stats ref="allRecords" :paginator="paginator"
                       :refreshList="(sortAlias) => getRecords(1, false, null, sortAlias)"/>

        <div class="text-right">
          <paginate v-if="paginator"
                    v-model="paginator.current_page"
                    :page-count="paginator.last_page"
                    ref="Pagination"
                    :page-range="11"
                    :margin-pages="2"
                    :click-handler="getRecords"
                    :prev-text="'&laquo'"
                    :next-text="'&raquo'"
                    :container-class="'pagination'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                    :active-class="'active green_btn'">
          </paginate>
        </div>
        <!--        </template>-->
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import Paginate from 'vuejs-paginate'
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import EmptyCardModal from "@/components/modals/EmptyCardModal.vue";
import MultiTaskFromStat from "@/views/statistics/components/MultiTaskFromStat.vue";
import store from "@/store";
import {customUpdateData} from "@/eventsBus";
import Multiselect from 'vue-multiselect'
import OutsorceCallTask from "@/components/drugs/tasks/OutsorceCallTask.vue";
import moment from "moment";
import LoadStoreTrendData from "@/views/statistics/components/LoadStoreTrendData.vue";
import ScanFilters from "@/views/statistics/components/tasksType/ScanFilters.vue";
import Table003Stats from "@/views/statistics/components/Table003Stats.vue";

export default {
  title: '003 статистика',
  components: {
    Table003Stats,
    ScanFilters,
    LoadStoreTrendData,
    OutsorceCallTask,
    MultiTaskFromStat,
    EmptyCardModal,
    LoadingButton,
    Multiselect,
    Paginate
  },
  data() {
    return {
      loadingObject: {
        newPairTaskBtn: {},
        drugBtnLoading: {},
      },
      hideReasons: {
        1: {value: 1, title: 'В списке контрол. веществ'},
        2: {value: 2, title: 'Не наша категория товара'},
        3: {value: 3, title: 'Другое', comment: true},
      },
      selectedTasks: [],
      tasksType: {
        22: {title: 'Прозвон по наличию', id: 22},
        23: {title: 'Описать цены', id: 23},
        24: {title: 'Привязать артикулы', id: 24},
        25: {title: 'Мониторинг справочных', id: 25},
      },
      modalData: null,
      loading: false,
      records: null,
      paginator: null,
      filter: {
        sb: '',
        mp: '',
        def: -1,
        hid: 3,
      },
      stringValues: ['title']
    }
  },
  computed: {
    $currentListOfRecords() {
      return this.$store.getters["recordsList/list"];
    },
    $GlobalDrawerData() {
      return this.$store.getters["platform/globalDrawerData"];
    },
  },
  created() {
    // this.getRecords();
    this.$store.dispatch("recordsList/setList", []);
    customUpdateData.$on('updateListById', async (id) => {
      await this.getRecords(1, true, id);
      if (this.$GlobalDrawerData?.data?.type) {
        this.$store.dispatch('platform/setGlobalDrawerData', {
          data: {
            record: this.$currentListOfRecords.find((r) => r.id === id),
            type: 'DrugStatisticMultiTask'
          },
          callBackAction: 'refreshMSStatList'
        })
      }
    });
    customUpdateData.$on('refreshMSStatList', (data) => {
      if (data && data?.update) {
        // this.getRecords(((this.paginator && this.paginator.current_page) ?? 1), true)
      }
    });
    customUpdateData.$on("updateDrugInMSStatList",
      async (data) => {
        // const index = this.records.findIndex((r) => r.drug_id === data.drug_id);
        // if (index === -1) return;
        // this.records[index].drug.related_drugs = data.related_drugs;
      });
  },
  methods: {
    getAllTypesOfTasks(record) {
      let arr = [...(record?.drug?.scan_tasks ?? [])];
      (record?.drug?.related_drugs ?? []).forEach((r) => {
        (r.drug?.details ?? []).forEach((d) => {
          if (d.task) arr.push({...d.task})
        });
      });
      return arr;
    },
    closeModal() {
      this.modalData = null;
    },
    async getRecords(page = 1, silent = false, recordId = null, sortAlias = null) {
      this.loading = !silent;
      let filter = Object.keys(this.filter).map(key => 'filter[' + key + ']=' + (this.stringValues.includes(key) ? this.filter[key] : +this.filter[key])).join('&');
      filter += '&filter[tt]=' + this.selectedTasks.map((t) => t.id).join(',');
      if (recordId) filter += ('&recId=' + recordId);
      if (sortAlias) {
        filter += '&sort[alias]=' + sortAlias + '&sort[dir]=' + this.$refs.allRecords.sorting[sortAlias]?.direction;
      }
      let {data: r_data} = await api.index('/statistics/003/drugs?page=' + page + '&' + filter);
      if (r_data.success) {
        if (recordId) {
          const index = this.$currentListOfRecords.findIndex((r) => r.id === recordId);
          if (index !== -1) {
            this.$nextTick(() => {
              this.$currentListOfRecords[index] = {
                ...r_data.records.data[0],
                all_tasks: this.getAllTypesOfTasks(r_data.records.data[0])
              };
              this.$store.dispatch("recordsList/setActiveRecord", {...this.$currentListOfRecords[index]});
              this.$store.dispatch("recordsList/setList", _.orderBy([...this.$currentListOfRecords], 'call', 'desc'));
            });
          }
        } else {
          const {data, ...pagination} = r_data.records
          const list = data.map((r) => {
            r.all_tasks = this.getAllTypesOfTasks(r);
            r.drug.tasks.forEach((t, i) => {
              if (!t.task_data?.drug) {
                r.drug.tasks[i].task_data.drug = {id: r.drug.id, title: r.drug.title, group: r.drug.group};
              }
            })
            return r;
          });
          const sortAlias = this.$refs.allRecords.activeSorting;
          this.$store.dispatch("recordsList/setList", _.orderBy(list,
            sortAlias, this.$refs.allRecords.sorting[sortAlias]?.direction));
          this.paginator = pagination;
        }
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
a.dropdown-item {
  text-decoration: none;
}

.dropdown-item i {
  margin-right: 3px;
}

input.form-control {
  height: 42px;
}

.old_record {
  background-color: #ffead29c;
}

.form-check label {
  margin-bottom: 0;
}
</style>
